export default {
  ZH_HK: {
    header_item_line1: "搜索",
    header_item_line2: "難度等級",
    header_item_line3: "請選擇",
    header_item_line4: "生成題目",
    header_item_line5: "開始",
    header_item_line6: "退出登錄",
    setting: "設置",
    topicName: "學科名稱",
    questionBank: "題庫名稱",
    confirm: "確認",
    cancel: "取消",
    input: "輸入",
    editQuestion: "題庫設置",
    version: "先導測試版",
    control: "教師控制器"
  },
  zh_cn: {
    header_item_line1: "搜索",
    header_item_line2: "难度等级",
    header_item_line3: "请选择",
    header_item_line4: "生成题目",
    header_item_line5: "开始",
    header_item_line6: "退出登录",
    setting: "设置",
    topicName: "学科名称",
    questionBank: "题库名称",
    confirm: "确认",
    cancel: "取消",
    input: "输入",
    editQuestion: "题库设置",
    version: "先导测试版",
    control: "教师控制器"
  },
  EN: {
    header_item_line1: "Search",
    header_item_line2: "Level",
    header_item_line3: "Select",
    header_item_line4: "Generate",
    header_item_line5: "Start",
    header_item_line6: "Log out",
    setting: "Setting",
    topicName: "Topic Name",
    questionBank: "Question Bank Name",
    confirm: "Confirm",
    cancel: "Cancel",
    input: "Input",
    editQuestion: "Question bank settings",
    version: "Beta",
    control: "Teacher controller"
  },
  es: {
    header_item_line1: "搜索",
    header_item_line2: "難度等級",
    header_item_line3: "請選擇",
    header_item_line4: "生成題目",
    header_item_line5: "開始",
    header_item_line6: "退出登錄",
    setting: "設置",
    topicName: "學科名稱",
    questionBank: "題庫名稱",
    confirm: "確認",
    cancel: "取消",
    input: "輸入",
    editQuestion: "題庫設置",
    version: "Beta",
    control: "Controlador del profesor"
  }
};
